module.exports = __webpack_public_path__ + "img/ph_right.09aa5eca.jpg";